const pageRedirectsData = [
    {
        name: 'Thermal Movement',
        from: '/systems/applied-benefits/#tab-panel-1',
        to: '/accommodating-thermal-movement/',
    },
    {
        name: 'Noise/Vibration',
        from: '/systems/applied-benefits/#tab-panel-2',
        to: '/noise-and-vibration-attenuation/',
    },
    {
        name: 'Grooved Technology',
        from: '/systems/mechanical-joining/#tab-panel-1',
        to: '/grooved-technology/',
    },
    {
        name: 'Compressed Sched',
        from: '/solutions/pipe-system-installation/#tab-panel-1',
        to: '/compressed-construction-schedules/',
    },
    {
        name: 'Simplified Maint',
        from: '/solutions/pipe-system-installation/#tab-panel-2',
        to: '/simplified-maintenance/',
    },
    {
        name: 'Confined Space',
        from: '/solutions/pipe-system-installation/#tab-panel-3',
        to: '/confined-space-installations/',
    },
    {
        name: 'Trade Compliance',
        from: '/company/#tab-panel-4',
        to: '/trade-compliance/',
    },
    {
        name: 'Become A Supplier',
        from: '/company/#tab-panel-3',
        to: '/become-a-supplier/',
    },
    {
        name: 'Code of Conduct',
        from: '/company/#tab-panel-2',
        to: '/code-of-conduct/',
    },
    {
        name: 'Innovation Timeline',
        from: '/company/#tab-panel-1',
        to: '/innovation-timeline/',
    },
    {
        name: 'Applications Engineering',
        from: '/services/#tab-panel-1',
        to: '/applications-engineering/',
    },
    {
        name: 'Safer System',
        from: '/solutions/pipe-system-installation/',
        to: '/safer-system-installations/',
    },
    {
        name: 'Solutions',
        from: '/systems/applied-benefits/',
        to: '/solutions/',
    },
    {
        name: '',
        from: '/systems/mechanical-joining/',
        to: '/gasket-technology/',
    },
];

window.pageRedirectsData = pageRedirectsData;
